<script setup>
defineProps({
    isSignUp: {
        type: Boolean,
        default: false,
    },
})

const socialBaseUrl = `${import.meta.env.VITE_API_BASE_URL}v3/auth/oauth/`

const signupWithSocial = social => {
    window.location.href = `${socialBaseUrl}${social}`
}
</script>

<template>
    <div class="social-signup">
        <BaseButton
            class="button-social"
            button-type="facebook"
            fill
            @click="signupWithSocial('facebook')"
        >
            {{ isSignUp ? 'SIGN UP WITH' : 'LOG IN WITH' }} FACEBOOK
        </BaseButton>
        <BaseButton
            class="button-social"
            button-type="google"
            fill
            @click="signupWithSocial('google')"
        >
            {{ isSignUp ? 'SIGN UP WITH' : 'LOG IN WITH' }} GOOGLE
        </BaseButton>
        <BaseButton
            class="button-social"
            button-type="apple"
            fill
            @click="signupWithSocial('apple')"
        >
            {{ isSignUp ? 'SIGN UP WITH' : 'LOG IN WITH' }} APPLE
        </BaseButton>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.social-signup {
    margin-bottom: $s-m;
    .button-social {
        width: 100%;
        margin-bottom: $s-m;
    }
}
</style>
